/** ***********
*
* <show-conditions-of-use.component.ts v1.0>
*
* Copyright (c) 2022 AIRBUS OPERATIONS
*
* Contributors:
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*
* All rights reserved.
**************/

import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { EMPTY, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/auth.service';
import { ErrorTranslationService } from 'src/app/services/error-translation.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-show-conditions-of-use',
    templateUrl: './show-conditions-of-use.component.html',
    styleUrls: ['./show-conditions-of-use.component.scss'],
    standalone: false
})
export class ShowConditionsOfUseComponent implements OnDestroy {

    private subscription: Subscription = new Subscription();
    public ongoingRequest = false;

    constructor(
        public dialogRef: MatDialogRef<ShowConditionsOfUseComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { validation: boolean },
        private userService: UserService,
        private _errorTranslationService: ErrorTranslationService,
        private _translate: TranslateService,
        public router: Router,
        public auth: AuthService,
        private readonly breakpointObserver: BreakpointObserver,
    ) {
        this.subscription.add(
            breakpointObserver.observe([
                Breakpoints.Handset,
            ]).subscribe(
                ({ matches }) => {
                    this.dialogRef.updateSize(
                        matches ? '100vw' : '75vw',
                        matches ? '100vh' : 'auto',
                    );

                }
            )
        );
    }

    close(): void {
        this.dialogRef.close();
    }

    validate() {
        this.ongoingRequest = true;
        this.subscription.add(this.userService.setUserValidation().pipe(
          catchError(error => {
            this._errorTranslationService.handleError(error, this._translate.instant('BANNER_FAIL_SET_USER_VALIDATION'));
            this.ongoingRequest = false;
            return EMPTY;
          }),
        ).subscribe(() => {
            this.auth.setAccept(true);
            this.ongoingRequest = false;
            this.dialogRef.close();
        }));
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
